import React from 'react';
import { connect } from 'react-redux';
import { hideShopDetails } from '../actions';
import Text from '../containers/Text';
import RouteLink from '../components/RouteLink';
import Address from '../components/Address';
import Phone from '../components/Phone';
import OpeningTimes from '../components/OpeningTimes';
import ShopBenefits from '../components/ShopBenefits';
import hpsf from '../sources/HermesPSF';
import SocialButtons from '../components/SocialButtons';
import HolidayAlert from '../components/HolidayAlert';
import { TranslatedLink } from '../containers/Text';

import logo from '../images/parcelshop-logo-2.svg';
import logoPaketParcelLock from '../images/paketParcelLock-logo-2.svg';

const addHttpToUrl = url => {
  if (url.match(/^https?\:\/\//)) {
    return url;
  } else {
    return 'http://' + url;
  }
}

const AdditionalInformation = (overlay) => {
  if (overlay.isMediaMarktParcel) {
    return (
      <div className="col-4 hint-paket-parcel-lock-wrapper">
        <h6>
          <Text id='details.hint.paketParcelLock.headline' />
        </h6>
        <div>
          <Text id='details.hint.parcel-shop.media-markt.copy' />
        </div>
      </div>
    )
  }

  if (overlay.isPaketParcelLock) {
    return (
      <div className="col-4 hint-paket-parcel-lock-wrapper">
        <h6>
          <Text id='details.hint.paketParcelLock.headline' />
        </h6>
        <div>
          <Text id='details.hint.paketParcelLock.copy' />
          <TranslatedLink href='details.hint.paketParcelLock.link-url' text='details.hint.paketParcelLock.link-text'
            className='paketParcelLock-link' target='_blank' webtrekk={true} />
        </div>
      </div>
    )
  }

  return null
}

const ShopDetailOverlay = ({ overlay, onCloseClick }) => {
  if (!overlay) {
    return null;
  }

  const hasAdditionalInformation = overlay.isMediaMarktParcel || overlay.isPaketParcelLock;

  const address = {
    street: overlay.street,
    houseNumber: overlay.houseNumber,
    zip: overlay.zip,
    city: overlay.city
  };

  // trigger the tracking requests manually
  window.wts.push(['send', 'page', {
    contentId: 'PaketShop Detailseite',
    customParameter: { 20: overlay.parcelShopNumber }
  }]);

  return (
    <div className="detail-overlay">
      <div className="detail-overlay__main">
        <div className='container-fluid'>
          <div className="detail-overlay__title-bar">
            <div className="d-md-none mb-md-0 d-inline-block float-end">
              <button onClick={onCloseClick} className='btn btn-link pl-0'>
                <div className="halflings halflings-chevron-left"></div>
                <Text id='back' />
              </button>
            </div>

            <span className="detail-overlay__logo t-h3 hidden-sm-down">
              {overlay.isPaketParcelLock
                ? <div>
                  <img src={logoPaketParcelLock} alt="" />
                  <Text id='details.title.paketParcelLock' />
                </div>
                : <div>
                  <img src={logo} alt="" />
                  <Text id='details.title' />
                </div>
              }
            </span>

            <div className="d-none d-md-block text-end close-button-wrapper">
              <button onClick={onCloseClick} className='btn btn-link pe-0 mb-0'>
                <div className="halflings halflings-remove-circle"></div>
              </button>
            </div>
          </div>

          <HolidayAlert shop={overlay} />

          <div className="row mb-2">
            <div className={`col-${hasAdditionalInformation ? '4' : '8'}`}>
              <h3 className={`t-h3 detail-overlay__name${overlay.isPaketFuxx ? ' paketfuxx' : ''}`}>{overlay.description || overlay.name}</h3>
              <p className="t-mb mb-0">{overlay.contactPerson || ''}</p>
              <Address {...address} inline={false} />
              <RouteLink end={address} className='pl-0 mb-sm' text='route-link.detail' />
              <br />
              <Phone phoneNumber={overlay.phone} isQuickInfo={false} className='mb-sm' />
              {overlay.url ? (
                <a href={addHttpToUrl(overlay.url)} target="_blank" className="website-link">
                  <div className="halflings halflings-globe"></div>
                  {' '} <span>{overlay.url}</span>
                </a>
              ) : null}
            </div>

            <AdditionalInformation {...overlay} />

            <div className='col-4 text-end'>
              <img src={
                hpsf.getParcelShopImageById(overlay.parcelShopNumber)}
                alt={`Hermes PaketShop ${overlay.description || overlay.name} ${address.city}`} />
            </div>
          </div>

          <div className="row">
            <div className="col-md-5 mb-2">
              <h3 className='t-h4 mb-1'><Text id='details.opening-hours' /></h3>
              <OpeningTimes hours={overlay.hours} isPaketParcelLock={overlay.isPaketParcelLock} />
            </div>

            <div className="col-md-7 mb-2">
              <h3 className='t-h4 mb-1'><Text id='services' /></h3>
              <ShopBenefits {...overlay} showDefaults={true} />
            </div>
          </div>

          <div className='row'>
            <div className='col-12 mb-sm'>
              <SocialButtons
                parcelShopNumber={overlay.parcelShopNumber}
                shopName={overlay.description || overlay.name}
                shopOwner={overlay.contactPerson || ''}
                shopAddress={address}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-12 mb-md">
              <div className="t-sm text-muted">
                <Text id='details.parcelShopNumber' />: {overlay.parcelShopNumber}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapDispatchToProps = dispatch => ({
  onCloseClick: () => dispatch(hideShopDetails())
});

const mapStateToProps = ({ overlay, shops }) => ({
  overlay: !!overlay ? shops[overlay] : null
});

export default connect(mapStateToProps, mapDispatchToProps)(ShopDetailOverlay);
